import { Navigate } from "react-router-dom";

export default function BrowseCorporateCategory() {
  return <Navigate to="/corporate-list" replace />;
}
